import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class EmployeeRecordPlantWise extends Component {
    constructor(props) {
        super(props)
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.accountTransactionServices = new AccountTransactionServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            itemObject: {
                idPlant: 0,
                plantList: [],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                itemCategoryName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "item category name"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            // this.getMasterExpenseAccGroupCount();
        })
    };

    onRowDoubleClicked = (event) => {
        this.getMasterExpenseAccountGroupSelectbyID(event.data.idAccountGroup);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.value;
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let itemObject = this.state.itemObject;
        itemObject.processNo = "";
        itemObject.processName = "";
        itemObject.processDesc = "";
        itemObject.remarks = "";
        this.setState({
            itemObject: itemObject, validState: validState
        });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.getAllDropdownForStockMaster();
                // this.getMasterExpenseAccGroupCount();
            });
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        // this.gridApi.showLoadingOverlay();
    };

    procSelectAllRecordsSP = () => {
        //let request = [this.state.idCompany, this.state.itemObject.idPlant, identity, 'Employee Record Plant Wise'];
        let request = {
            formname: "Employee Record Plant Wise",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            idPlant: this.state.itemObject.idPlant,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        data.forEach((x) => {
                            x.Select = x.plantStatus === 'YES' ? true : false;
                        });
                        const columnPriority = [
                            "Select", "employeeCode", "emp_ContactNo", "employeeName",];
                        const allKeys = Object.keys(data[0]);
                        const sortedKeys = allKeys.sort((a, b) => {
                            const indexA = columnPriority.indexOf(a);
                            const indexB = columnPriority.indexOf(b);
                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return 1;
                            if (indexB === -1) return -1;
                            return indexA - indexB;
                        });

                        const dynamicColDefs = sortedKeys.map((key) => {
                            const isSelectColumn = key === "Select";

                            return {
                                field: key.includes(".") ? key.replace(/\./g, "_") : key,
                                headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                                minWidth: this.getColumnWidth(key) !== undefined
                                    ? this.getColumnWidth(key)
                                    : window.innerWidth * 0.06,
                                flex: 1,
                                filter: true,
                                floatingFilter: true,
                                hide: ["idEmployee", "plantStatus"].includes(key),
                                width: this.getPinnedWidth(key),
                                valueGetter: (params) => params.data[key],
                                ...(isSelectColumn && {
                                    headerCheckboxSelection: true,
                                    //checkboxSelection: true,
                                    cellRenderer: 'agCheckboxCellRenderer',
                                    editable: true, // Optional: allow user to toggle checkbox
                                }),
                            };
                        });

                        // Update state with row data and column definitions
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                        });
                        this.setPermissions(permissions);
                    } else {
                        this.setPermissions(permissions);
                        // Empty state if no data
                        this.setState({
                            rowData: [],
                            colDefs: [],
                        });
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }
    getColumnWidth = (key) => {
        const colwidth = {
            "employeeName": window.innerWidth * 0.35,
            "emp_ContactNo": window.innerWidth * 0.2,
            "employeeCode": window.innerWidth * 0.08,
            "Select": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getAllDropdownForStockMaster = () => {
        this.masterEntryServices.getAllDropdownForStockMaster(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.itemObject;
                data.plantList = allData.filter(item => item.source === 'Master_Plant');
                this.setState({
                    itemObject: data,
                });
            }
        });
    }

    viewRecord = (identity) => {
        let request = [this.state.idCompany, this.state.itemObject.idPlant, identity, 'Employee Record Plant Wise'];
        this.masterEntryServices.getMasteEmployeeSelectForPlant(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;

                if (data.length > 0) {
                    data.forEach((x) => {
                        x.Select = x.plantStatus === 'YES' ? true : false;
                    });
                    const columnPriority = [
                        "Select", "employeeCode", "emp_ContactNo", "employeeName",];
                    const allKeys = Object.keys(data[0]);
                    const sortedKeys = allKeys.sort((a, b) => {
                        const indexA = columnPriority.indexOf(a);
                        const indexB = columnPriority.indexOf(b);
                        if (indexA === -1 && indexB === -1) return 0;
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                    });

                    const dynamicColDefs = sortedKeys.map((key) => {
                        const isSelectColumn = key === "Select";

                        return {
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined
                                ? this.getColumnWidth(key)
                                : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idEmployee", "plantStatus"].includes(key),
                            width: this.getPinnedWidth(key),
                            valueGetter: (params) => params.data[key],
                            ...(isSelectColumn && {
                                headerCheckboxSelection: true,
                                //checkboxSelection: true,
                                cellRenderer: 'agCheckboxCellRenderer',
                                editable: true, // Optional: allow user to toggle checkbox
                            }),
                        };
                    });

                    // Update state with row data and column definitions
                    this.setState({
                        rowData: data,
                        colDefs: dynamicColDefs,
                    });
                } else {
                    // Empty state if no data
                    this.setState({
                        rowData: [],
                        colDefs: [],
                    });
                }
            }
        });
    }

    save = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.save);
            return;
        }
        let request = [];
        let data = this.state.rowData;
        data.map((x) => {
            if (x.Select === true) {
                let obj = {
                    idEmployee: x.idEmployee,
                    idplant: this.state.itemObject.idPlant,
                    idCompany: this.state.idCompany,
                    e_Date: new Date().toISOString(),
                };
                request.push(obj);
            }
        });
        if (request.length > 0) {
            this.masterEntryServices.saveMasterEmployeePlantWiseInsert(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    //let data = response.responseItem.responseContent;
                    this.SwalServices.Success("Save successfully.");
                    let data = this.state.itemObject;
                    data.idPlant = 0;
                    this.setState({
                        itemObject: data,
                        rowData: [],
                        colDefs: [],
                    });
                }
            });
        }
    }

    render() {
        return (
            <div className='tax-structure-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        {/* <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        /> */}
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[125px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 237px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] pt-[0]">Employee record plant wise</h1>
                                </div>
                                <div className='item-grp grid grid-cols-3 gap-2.5 my-3.5 items-end'>
                                    <div className='input-grp col-span-2'>
                                        <label>Select plant</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Rate"
                                            options={this.state.itemObject.plantList}
                                            value={this.state.itemObject.idPlant ? this.state.itemObject.plantList.find(x => x.value === this.state.itemObject.idPlant) : 0}
                                            onChange={(event) =>
                                                this.handleChange(event, "idPlant")
                                            }
                                            className={this.state.validState?.error?.idPlant !== undefined ? "error" : ""}
                                        />
                                    </div>
                                    <div className='btn-grp flex gap-2.5'>
                                        <button className="update-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => this.procSelectAllRecordsSP()}>View records</button>
                                        {/* <button className="edit-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => this.viewRecord("")}>Old records</button> */}
                                        {this.state.rowData.length > 0 ?
                                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => this.save()}>Save</button>
                                            :
                                            null
                                        }
                                    </div>
                                </div>

                                <AgGridReact
                                    rowData={this.state.rowData}
                                    columnDefs={this.state.colDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate={'<span>No Rows To Show</span>'}

                                    rowSelection="multiple"
                                    onRowClicked={this.onRowClicked}
                                    onCellValueChanged={this.onCellValueChanged}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
